// Funzione per aggiornare il metafield visualizzato
function updateVariantMetafield(variantId, variantMetafields) {
  const displayElement = document.getElementById('variant-metafield-display');
  
  if (displayElement) {
    const metafieldValue = variantMetafields[variantId];
    
    // Verifica che il valore esista e sia una stringa
    if (metafieldValue && typeof metafieldValue === 'string') {
      displayElement.innerHTML = metafieldValue.replace(/\n/g, '<br>');
      displayElement.style.display = 'block';
    } else {
      displayElement.innerHTML = '';
      displayElement.style.display = 'none';
    }
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  if (typeof window.variantMetafields === 'undefined') return;
  
  // Intercetta l'URL change che Dawn usa per le varianti
  const productForm = document.querySelector('product-form, .product-form');
  
  if (productForm) {
    // Observer per intercettare i cambiamenti nell'URL (Dawn aggiorna ?variant=)
    let lastVariantId = new URLSearchParams(window.location.search).get('variant');
    
    // Inizializza con la variante corrente
    if (lastVariantId) {
      updateVariantMetafield(lastVariantId, window.variantMetafields);
    }
    
    // Monitora i cambiamenti nell'URL
    const observer = new MutationObserver(function() {
      const currentVariantId = new URLSearchParams(window.location.search).get('variant');
      if (currentVariantId && currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        updateVariantMetafield(currentVariantId, window.variantMetafields);
      }
    });
    
    observer.observe(document.querySelector('body'), {
      childList: true,
      subtree: true
    });
    
    // Intercetta anche i click sui pulsanti/radio delle varianti
    document.addEventListener('click', function(e) {
      const variantInput = e.target.closest('input[name="id"], fieldset.js input');
      if (variantInput) {
        setTimeout(function() {
          const variantId = new URLSearchParams(window.location.search).get('variant') || variantInput.value;
          if (variantId) {
            updateVariantMetafield(variantId, window.variantMetafields);
          }
        }, 100);
      }
    });
    
    // Intercetta anche i change sui select
    document.addEventListener('change', function(e) {
      if (e.target.matches('select[name="id"]')) {
        setTimeout(function() {
          const variantId = new URLSearchParams(window.location.search).get('variant') || e.target.value;
          if (variantId) {
            updateVariantMetafield(variantId, window.variantMetafields);
          }
        }, 100);
      }
    });
  }
}
